import Constants from 'constants';

const _defaultState = {
    success: null,
    fetching: false,
    fetchingMore: true,
    fetchingIds: false,
    sortBy: {},
    fetchingLocations: false,
    locationsApi: [],
    geocodeApi: {},
    locationFilter: {},
    tripAdvisorIds: [],
    tripAdvisorData: [],
    listMaster: [],
    listFiltered: [],
    filters: {},
    searchIds: [],
    meta: {},
    retryCount: 0,
    hotelName: '',
    linkedUsers: {},
    fetchingLinkedUser: false,
    fetchingSwitchUser: false,
    linkedUserError: {},
    regionInfo: {},
    subRegionSelectedPayload: [],
    addToFavourite: {},
    isFavourite: []
},

    hotelListing = (state = _defaultState, action) => {
        try {
            const { type, payload, status } = action;
            switch (type) {
                case Constants.actions.SEARCH.SEARCH_RESULTS_FETCH_MORE: {
                    return {
                        ...state,
                        listMaster: [
                            ...payload
                        ],
                        listFiltered: [
                            ...payload
                        ],
                        fetching: false,
                        fetchingMore: true,
                        retryCount: state.retryCount + 1
                    }
                }
                case Constants.actions.SEARCH.APPLY_LOCATION_FILTER: {
                    return {
                        ...state,
                        locationFilter: payload
                    }
                }
                case Constants.actions.SEARCH.FETCHING_LOCATIONS: {
                    return {
                        ...state,
                        fetchingLocations: true
                    }
                }
                case Constants.actions.SEARCH.LOCATIONS_DATA: {
                    return {
                        ...state,
                        fetchingLocations: false,
                        locationsApi: payload
                    }
                }
                case Constants.actions.SEARCH.SEARCH_GEOCODE: {
                    return {
                        ...state,
                        geocodeApi: payload
                    }
                }
                case Constants.actions.SEARCH.SET_SEARCH_IDS_SUCCESS: {
                    return {
                        ...state,
                        searchIds: payload,
                        fetchingIds: false
                    };
                }
                case Constants.actions.SEARCH.SET_SEARCH_IDS_FAILURE: {
                    return {
                        ...state,
                        fetchingIds: false
                    };
                }
                case Constants.actions.SEARCH.GET_TRIP_ADVISOR_IDS: {
                    return {
                        ...state,
                        tripAdvisorIds: [
                            ...payload
                        ]
                    };
                }
                case Constants.actions.SEARCH.SET_TRIP_ADVISOR_DATA: {
                    return {
                        ...state,
                        tripAdvisorData: [
                            ...state.tripAdvisorData,
                            ...payload
                        ]
                    };
                }
                case Constants.actions.SEARCH.UPDATE_FILTERS: {
                    return {
                        ...state,
                        filters: {
                            ...state.filters,
                            ...payload
                        },
                    };
                }
                case Constants.actions.SEARCH.SET_SORT_BY: {
                    return {
                        ...state,
                        sortBy: {
                            ...state.sortBy,
                            ...payload.sortBy
                        },
                        listFiltered: [
                            ...payload.sortedData
                        ]
                    };
                }
                case Constants.actions.SEARCH.APPLY_FILTERS: {
                    return {
                        ...state,
                        listFiltered: [
                            ...payload
                        ],
                    };
                }
                case Constants.actions.SEARCH.FETCHING_SEARCH_IDS: {
                    return {
                        ...state,
                        searchIds: [],
                        fetching: true,
                        fetchingIds: true
                    };
                }
                case Constants.actions.SEARCH.SEARCH_RESULT_SUCCESS:
                case Constants.actions.SEARCH.SEARCH_RESULT_FINISH: {
                    return {
                        ...state,
                        listMaster: [
                            ...payload
                        ],
                        listFiltered: [
                            ...payload
                        ],
                        fetching: false,
                        fetchingMore: false
                    };
                }
                case Constants.actions.SEARCH.FETCHING_LIST: {
                    return {
                        ...state,
                        fetching: true
                    };
                }
                case Constants.actions.SEARCH.SEARCH_RESULT_FAILURE: {
                    return {
                        ...state,
                        listFiltered: [],
                        listMaster: [],
                        meta: {},
                        fetching: false,
                        fetchingMore: false
                    };
                }
                case Constants.actions.SEARCH.SEARCH_RESULT_RETRY: {
                    return {
                        ...state,
                        retryCount: state.retryCount + 1
                    }
                }
                case Constants.actions.SEARCH.SEARCH_MODIFY_SEARCH: {
                    return {
                        ...state,
                        listMaster: [],
                        meta: {},
                        listFiltered: [],
                        retryCount: 0,
                        fetching: true,
                        fetchingMore: true
                    }
                }
                case Constants.actions.SEARCH.GET_HOTEL_NAME:
                    return {
                        ...state,
                        hotelName: payload
                    }

                case Constants.actions.SEARCH.LINKED_USERS_INFO:
                    return {
                        ...state,
                        linkedUsers: payload,
                        fetchingLinkedUser: false
                    }
                case Constants.actions.SEARCH.FETCHING_LINKED_USERS:
                    return {
                        ...state,
                        fetchingLinkedUser: true
                    }
                case Constants.actions.SEARCH.FETCHING_SWITCH_USER:
                    return {
                        ...state,
                        fetchingSwitchUser: true
                    }
                case Constants.actions.SEARCH.FETCHED_SWITCH_USER:
                    return {
                        ...state,
                        fetchingSwitchUser: false
                    }
                case Constants.actions.SEARCH.SET_LINKED_USER_ERROR:
                    return {
                        ...state,
                        linkedUserError: payload
                    }
                case Constants.actions.SEARCH.REMOVE_LINKED_USER_ERROR:
                    return {
                        ...state,
                        linkedUserError: {}
                    }
                case Constants.actions.SEARCH.GET_REGION_INFO: {
                    return {
                        ...state,
                        regionInfo: payload
                    };
                }
                case Constants.actions.SEARCH.GET_SUBREGION_SELECTED_VALUE: {
                    return {
                        ...state,
                        subRegionSelectedPayload: payload
                    };
                }
                case Constants.actions.SEARCH.GET_ADDTOFAVOURITE_RESPONSE: {
                    const { status = {} } = payload,
                        { success = false } = status
                    return {
                        ...state,
                        addToFavourite: status
                    };
                }
                case Constants.actions.SEARCH.FAVOURITE_OPTIONS: {
                    return {
                        ...state,
                        isFavourite: payload
                    };
                }
                default:
                    return state;
            }
        } catch (error) {
            return _defaultState;
        }
    };

export default hotelListing;
